import { FilterData } from 'path-shared/models/filter-data';
import { SortDirection } from '@angular/material';


export class ZonesFilter extends FilterData {

  id: number;
  nomZona: string;
  idMunicipi: string;

  constructor(sortField: string, sortDir: SortDirection) {
    super(sortField, sortDir);
    this.id = null;
    this.nomZona = '';
    this.idMunicipi = '';

    this.labels['id'] = this.i18n('Id');
    this.labels['nomZona'] = this.i18n('NomZona');
    this.labels['idMunicipi'] = this.i18n('Municipi');
  }

}
